import type { TriggerConfig } from "../shared/types.js";

const ARROW_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>`;

interface TriggerButtonProps {
  config: TriggerConfig;
  logoUrl: string;
  onClick: () => void;
}

export function TriggerButton({ config, logoUrl, onClick }: TriggerButtonProps) {
  const isNewLayout = config.variant === "primary" || config.variant === "outline";

  return (
    <div
      class={`text-center ${config.width === "full" ? "w-full" : "w-fit"}`}
      style={config.glass ? {
        background: "rgba(255,255,255,0.1)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        borderRadius: `calc(${config.borderRadius}px + 6px)`,
        padding: "20px",
        boxShadow: "0 8px 32px 0 rgba(31,38,135,0.15)",
      } : undefined}
    >
      {config.label && (
        <div
          class={`font-medium ${isNewLayout ? "text-center" : "text-left"} mb-2`}
          style={{
            color: config.colors.label,
            fontSize: `${config.fontSize * 0.8}px`,
          }}
        >
          {config.label}
        </div>
      )}

      <div class="flex items-center w-full relative">
        <div
          class={`flex items-center justify-center absolute top-0 z-[3] cursor-pointer ${isNewLayout ? "left-0" : "right-0"}`}
          style={{
            backgroundColor: config.colors.logo,
            borderRadius: `${config.borderRadius}px`,
            height: `${config.height}px`,
            padding: `${(config.height - config.logoSize) / 2}px`,
            border: isNewLayout ? "none" : config.buttonBorder,
          }}
          onClick={onClick}
        >
          <img
            src={logoUrl}
            alt="FormVue"
            class="shrink-0"
            style={{ width: `${config.logoSize}px`, height: `${config.logoSize}px` }}
          />
        </div>

        <button
          type="button"
          class="border-0 cursor-pointer flex items-center justify-center font-medium overflow-hidden h-full whitespace-nowrap shrink-0 p-0 hover:brightness-90"
          style={{
            backgroundColor: config.variant === "outline" ? "white" : config.variant === "primary" ? "#0a0a0a" : config.colors.button,
            color: config.variant === "outline" ? "#0a0a0a" : config.variant === "primary" ? "#fafafa" : config.colors.buttonText,
            borderRadius: `${config.borderRadius}px`,
            fontFamily: "system-ui, -apple-system, sans-serif",
            height: `${config.height}px`,
            flex: "1 1 auto",
            border: config.variant === "outline" ? "1px solid #e5e5e5" : config.buttonBorder,
            paddingLeft: isNewLayout ? `${config.height + 12}px` : undefined,
            paddingRight: isNewLayout ? undefined : `${config.height + 12}px`,
            gap: isNewLayout ? "16px" : undefined,
          }}
          onClick={onClick}
        >
          <span
            class="flex items-center justify-center whitespace-nowrap flex-1"
            style={{
              fontSize: `${config.fontSize}px`,
              padding: isNewLayout ? "0" : "0 0 0 12px",
            }}
          >
            {config.text}
          </span>
          {isNewLayout && (
            <span
              class="flex items-center shrink-0"
              style={{ paddingRight: "16px" }}
              dangerouslySetInnerHTML={{ __html: ARROW_SVG }}
            />
          )}
        </button>
      </div>
    </div>
  );
}
